// extracted by mini-css-extract-plugin
module.exports = {"outline":"outline_outline__DPDap","main":"outline_main__2f72W","side":"outline_side__2JEUU","slidewrap":"outline_slidewrap__2b2NC"};